import { coreApi } from "./coreApi";

const rattingApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllStoresRatting: builder.query({
      query: (page) => ({
        url: `/stores/ratings?page=${page}`,
        method: "GET",
      }),
      providesTags: ["Ratting"],
    }),
  }),
});

export const { useGetAllStoresRattingQuery, useLazyGetAllStoresRattingQuery } = rattingApi;

export default rattingApi;
